import { ScrollArticleLabelTheme } from '@/components/ScrollArticleLabel/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const ScrollArticleLabel = GenericSlot({ as: 'h5', theme: ScrollArticleLabelTheme });
